function getLongestPrefixSuffix(term) {
  const termLength = term.length;
  const lps = [termLength];
  lps[0] = 0;
  let start = 0;
  let end = 1;
  while (end < termLength) {
    if (term[start] === term[end]) {
      start++;
      lps[end] = start;
      end++;
    } else if (start === 0) {
      lps[end] = 0;
      end++;
    } else {
      start = lps[start - 1];
    }
  }
  return lps;
}

function kmpSearch(item, lps, searchTerm) {
  const itemLength = item.length;
  const termLength = searchTerm.length;

  let itemIndex = 0;
  let termIndex = 0;

  while (itemIndex < itemLength && termIndex < termLength) {
    if (item[itemIndex] === searchTerm[termIndex]) {
      itemIndex++;
      termIndex++;
    } else if (termIndex === 0) {
      itemIndex++;
    } else {
      termIndex = lps[termIndex - 1];
    }
  }
  return termIndex === termLength;
}

/**
 * Uses an implementation of the Knuth-Morris-Pratt algorithm to do a substring
 * search on an array of strings
 * @param {string} searchTerm - a substring to search for
 * @param {string[]} stringsToSearch - an array of strings to search
 * @returns {string[]} strings that included the searchTerm
 */
export default function substringSearch(searchTerm, stringsToSearch = []) {
  const numberOfStringsToSearch = stringsToSearch.length;
  if (!searchTerm || numberOfStringsToSearch === 0) {
    return [];
  }
  const matches = [];
  const lps = getLongestPrefixSuffix(searchTerm);
  for (let i = 0; i < numberOfStringsToSearch; i++) {
    const stringToSearch = stringsToSearch[i];
    if (kmpSearch(stringToSearch, lps, searchTerm)) {
      matches.push(stringToSearch);
    }
  }

  return matches;
}
